var map = {
	"./10_sahyadrihospitals.svg": 210,
	"./11_omh_omega.svg": 211,
	"./12_calibre.svg": 212,
	"./13_chemopharm.svg": 213,
	"./14_cpc.svg": 214,
	"./15_fandbasia.svg": 215,
	"./16_harrys.svg": 216,
	"./17_burgerking.svg": 217,
	"./1_cipla.svg": 205,
	"./2_tatapower.svg": 206,
	"./3_licious.svg": 207,
	"./4_apollo.svg": 1000,
	"./5_cochinshipyard.svg": 208,
	"./6_pricol.svg": 1001,
	"./7_everstone.svg": 209,
	"./8_api.svg": 1002,
	"./Ankitha-B.svg": 1003,
	"./Background.svg": 1004,
	"./BelindaSabatierMondjo.svg": 243,
	"./Blog23.jpg": 1005,
	"./California.jpg": 312,
	"./Chinthan.svg": 1006,
	"./Divyashree-C.svg": 1007,
	"./EU.jpg": 313,
	"./G7Countries.jpg": 314,
	"./Global.jpg": 315,
	"./Mithun-Suvarna.svg": 1008,
	"./Nithesh-Padival.svg": 1009,
	"./Oct-Blog-image.jpg": 1010,
	"./Plant.png": 1011,
	"./Podcast-banner.jpg": 316,
	"./Podcast-banner.svg": 1012,
	"./RectangleBlue.svg": 1013,
	"./Sangath.svg": 1014,
	"./Saptham.svg": 1015,
	"./Sathwik-Rai.svg": 1016,
	"./Satish-Ramchandani.svg": 1017,
	"./Supreeth-Rao.svg": 1018,
	"./Switzerland.jpg": 317,
	"./Thailand.jpeg": 1019,
	"./UAE.jpg": 318,
	"./aarksee.jpg": 195,
	"./accenture.png": 1020,
	"./accenture.svg": 172,
	"./ais.png": 173,
	"./analytics.mp4": 1021,
	"./apr2023-1.jpg": 319,
	"./apr2023-2.jpg": 320,
	"./apr2023-3.jpg": 321,
	"./apr2023-4.jpg": 322,
	"./apr2023-5.jpg": 323,
	"./apr2024-1.jpg": 324,
	"./apr2024-2.jpg": 325,
	"./apr2024-3.jpg": 326,
	"./apr2024-4.jpg": 327,
	"./apr2025_austrelia.webp": 1022,
	"./apr2025_cdfr.webp": 328,
	"./apr2025_crf.webp": 329,
	"./apr2025_decarbon.webp": 330,
	"./apr2025_ifrs.webp": 331,
	"./apr2025_steel.webp": 332,
	"./august2023-1.jpg": 151,
	"./august2023-2.jpg": 333,
	"./august2023-3.jpg": 334,
	"./august2023-4.jpg": 335,
	"./august2023-5.jpg": 336,
	"./august2024-1.jpg": 337,
	"./august2024-2.jpg": 338,
	"./august2024-3.jpg": 339,
	"./august2024-4.jpg": 340,
	"./august2024-5.jpg": 341,
	"./aus_feb_2025.webp": 342,
	"./bg-landingpage.svg": 1023,
	"./blog-12.svg": 1024,
	"./blue-bg-img.svg": 1025,
	"./blueOceanSystems.png": 174,
	"./blueSky.png": 175,
	"./canada-vpj.jpg": 1026,
	"./canada.jpg": 343,
	"./careerCollage.webp": 171,
	"./careersBanner.svg": 170,
	"./cementIndustry.jpg": 1027,
	"./ciplaImg.svg": 1028,
	"./client_logos/aarti.svg": 137,
	"./client_logos/amararaja.svg": 138,
	"./client_logos/amiOrganicsLogo.svg": 117,
	"./client_logos/apollohospitals.svg": 344,
	"./client_logos/ashokLeyland.svg": 125,
	"./client_logos/aveo.svg": 345,
	"./client_logos/ayana.svg": 67,
	"./client_logos/birlaGroupLogo.svg": 120,
	"./client_logos/bitmore.svg": 346,
	"./client_logos/bluePlanet.svg": 129,
	"./client_logos/burgerking.svg": 347,
	"./client_logos/calibre.svg": 348,
	"./client_logos/ceat.svg": 102,
	"./client_logos/cgpower.svg": 68,
	"./client_logos/chemopharm.svg": 69,
	"./client_logos/cipla.svg": 349,
	"./client_logos/cochinshipyard.svg": 350,
	"./client_logos/cohizon.svg": 351,
	"./client_logos/cookieman.svg": 352,
	"./client_logos/cpc.svg": 70,
	"./client_logos/cumiLogo.svg": 121,
	"./client_logos/data_esg.svg": 66,
	"./client_logos/deepak_nitrite_logo.svg": 108,
	"./client_logos/dominos.svg": 353,
	"./client_logos/dsg.svg": 354,
	"./client_logos/emrill.svg": 71,
	"./client_logos/epsilonLogo.svg": 118,
	"./client_logos/escortsKubota.svg": 130,
	"./client_logos/eveready.svg": 139,
	"./client_logos/everenviro.svg": 73,
	"./client_logos/everest_industrial_logo.svg": 109,
	"./client_logos/everise.svg": 74,
	"./client_logos/everlife-1.svg": 76,
	"./client_logos/everlife.svg": 75,
	"./client_logos/eversource.svg": 77,
	"./client_logos/everstone.svg": 355,
	"./client_logos/fnb_asia.svg": 356,
	"./client_logos/freshways.svg": 357,
	"./client_logos/ghcl.svg": 101,
	"./client_logos/gmr.svg": 140,
	"./client_logos/gokaldasExports.svg": 126,
	"./client_logos/grInfra.svg": 127,
	"./client_logos/greencell.svg": 78,
	"./client_logos/harrys.svg": 358,
	"./client_logos/harrys_logo.svg": 110,
	"./client_logos/hcl.svg": 359,
	"./client_logos/hinduja.svg": 145,
	"./client_logos/igarashiMotors.svg": 128,
	"./client_logos/iifl_finance.svg": 79,
	"./client_logos/indoramaCorporation.svg": 131,
	"./client_logos/indospace.svg": 80,
	"./client_logos/indostar.svg": 81,
	"./client_logos/infostretch.svg": 82,
	"./client_logos/infosys.svg": 360,
	"./client_logos/ips.svg": 146,
	"./client_logos/jKCements.svg": 123,
	"./client_logos/jsla.svg": 141,
	"./client_logos/kathari.svg": 83,
	"./client_logos/kuantumPapers.svg": 124,
	"./client_logos/lTFinance.svg": 132,
	"./client_logos/lakshmimachineworks.svg": 84,
	"./client_logos/licious.svg": 361,
	"./client_logos/lithium.svg": 85,
	"./client_logos/lloyd_metals.svg": 111,
	"./client_logos/lodha.svg": 362,
	"./client_logos/lupin.svg": 86,
	"./client_logos/mastek.svg": 112,
	"./client_logos/multiples.svg": 104,
	"./client_logos/narayanaHealthLogo.svg": 122,
	"./client_logos/omega_healthcare.svg": 363,
	"./client_logos/pgp_glass.svg": 87,
	"./client_logos/polycycle.png": 364,
	"./client_logos/polyplastics.svg": 133,
	"./client_logos/pricol.svg": 365,
	"./client_logos/prism-johnson.svg": 134,
	"./client_logos/protean_logo.svg": 366,
	"./client_logos/radiaant_logo.svg": 113,
	"./client_logos/radiance.svg": 88,
	"./client_logos/rakbank.svg": 147,
	"./client_logos/ramco.svg": 89,
	"./client_logos/re_sustainability.svg": 90,
	"./client_logos/refex.svg": 106,
	"./client_logos/republicBank.svg": 105,
	"./client_logos/rhi_magnesita.svg": 91,
	"./client_logos/sahyadri.svg": 92,
	"./client_logos/sbi_card.svg": 72,
	"./client_logos/servion.svg": 93,
	"./client_logos/shapoorji_pallonji_logo.svg": 114,
	"./client_logos/shoprite.svg": 149,
	"./client_logos/sjs.svg": 94,
	"./client_logos/skf.svg": 367,
	"./client_logos/softgel.svg": 95,
	"./client_logos/sohanlal.svg": 96,
	"./client_logos/sulochana.svg": 103,
	"./client_logos/sunpharma.svg": 97,
	"./client_logos/supremeLogo.svg": 115,
	"./client_logos/sutherlandLogo.svg": 119,
	"./client_logos/suzlonLogo.svg": 116,
	"./client_logos/tata-consumer-products.svg": 135,
	"./client_logos/tata-projects.svg": 144,
	"./client_logos/tatapower.svg": 98,
	"./client_logos/tech-mahindra-ctco.svg": 148,
	"./client_logos/tolaram.svg": 99,
	"./client_logos/translumina.svg": 100,
	"./client_logos/trident.svg": 136,
	"./client_logos/uflex.svg": 142,
	"./client_logos/wns.svg": 143,
	"./client_logos/zahid_group.svg": 368,
	"./client_logos/zee.svg": 107,
	"./client_logos/zomato.svg": 369,
	"./clients/11_dsg.svg": 232,
	"./clients/12_burger.svg": 233,
	"./clients/13_cohizon.svg": 234,
	"./clients/14_everstone.svg": 235,
	"./clients/15_fnbasia.svg": 236,
	"./clients/16_skf.svg": 237,
	"./clients/17_calibre.svg": 238,
	"./clients/18_esgds.svg": 239,
	"./clients/19_bitmore.svg": 1029,
	"./clients/1_cipla.svg": 225,
	"./clients/20_lodha.svg": 240,
	"./clients/2_tata.svg": 226,
	"./clients/3_apollo.svg": 227,
	"./clients/4_pricol.svg": 1030,
	"./clients/5_cochin.svg": 228,
	"./clients/6_licious.svg": 229,
	"./clients/8_omega.svg": 230,
	"./clients/9_cookieman.svg": 231,
	"./dec2023-1.jpg": 370,
	"./dec2023-2.jpg": 371,
	"./dec2023-3.jpg": 372,
	"./dec2023-4.jpg": 373,
	"./dec2023-5.jpg": 374,
	"./dec2024-1.webp": 375,
	"./dec2024-2.webp": 376,
	"./dec2024-3.webp": 377,
	"./dec2024-4.webp": 378,
	"./dec2024-5.jpeg": 379,
	"./digeto.png": 196,
	"./dmWorld.png": 176,
	"./dm_world.svg": 219,
	"./dnv.png": 1031,
	"./dnv.svg": 177,
	"./earthood.png": 178,
	"./eba_feb_2025.webp": 380,
	"./eba_thumbnail.jpeg": 1032,
	"./ecolibrium.svg": 222,
	"./empoweredAnalytics.png": 179,
	"./eu_feb_2025.webp": 381,
	"./europe.jpg": 382,
	"./facilityManagement.jpg": 1033,
	"./feb2023-1.jpg": 383,
	"./feb2023-2.jpg": 384,
	"./feb2023-3.jpg": 385,
	"./feb2023-4.jpg": 386,
	"./feb2023-5.jpg": 387,
	"./feb2024-1.jpg": 388,
	"./feb2024-2.jpg": 389,
	"./feb2024-3.jpg": 390,
	"./feb2024-4.jpg": 391,
	"./feb2024-5.jpg": 392,
	"./fmcgCase.jpg": 1034,
	"./fuel_feb_2025.webp": 393,
	"./grantThornton.jpg": 197,
	"./green-bg-img.svg": 1035,
	"./greenBeeEnergy.png": 180,
	"./greenConsults.jpg": 202,
	"./greenbee.svg": 220,
	"./handImg.jpg": 1036,
	"./hcl.svg": 181,
	"./header-green-bg.svg": 1037,
	"./healthCare.jpg": 1038,
	"./honeycomb-mobile.svg": 1039,
	"./honeycomb.svg": 1040,
	"./ifcom.jpg": 183,
	"./ifrs_thumbnail.jpeg": 1041,
	"./image4.png": 394,
	"./image_4.jpg": 395,
	"./img_1.jpg": 396,
	"./img_2.jpg": 397,
	"./img_3.jpg": 398,
	"./img_4.jpg": 399,
	"./img_5.jpg": 1042,
	"./imss.png": 182,
	"./india_map.svg": 1043,
	"./itqan.png": 184,
	"./jan1.jpg": 400,
	"./jan2.jpg": 401,
	"./jan2024-1.jpg": 402,
	"./jan2024-2.jpg": 403,
	"./jan2024-3.jpg": 404,
	"./jan2024-4.jpg": 405,
	"./jan2024-5.jpg": 406,
	"./jan3.jpg": 407,
	"./jan4.jpg": 408,
	"./jan5.jpg": 409,
	"./july2023-1.jpg": 410,
	"./july2023-2.jpg": 411,
	"./july2023-3.jpg": 412,
	"./july2023-4.jpg": 413,
	"./july2023-5.jpg": 414,
	"./july2024-1.jpg": 415,
	"./july2024-2.jpg": 416,
	"./july2024-3.jpg": 417,
	"./july2024-4.jpg": 418,
	"./july2024-5.jpg": 419,
	"./july_2025_1.jpg": 1044,
	"./july_2025_1.webp": 420,
	"./july_2025_2.webp": 421,
	"./july_2025_3.webp": 422,
	"./july_2025_4.webp": 423,
	"./july_2025_5.webp": 424,
	"./june2023-1.jpg": 425,
	"./june2023-2.jpg": 426,
	"./june2023-3.jpg": 427,
	"./june2023-4.jpg": 428,
	"./june2023-5.webp": 429,
	"./june2024-1.webp": 430,
	"./june2024-2.webp": 431,
	"./june2024-3.webp": 432,
	"./june2024-4.webp": 433,
	"./june2024-5.webp": 434,
	"./june_2025_1.jpeg": 1045,
	"./june_2025_1.webp": 435,
	"./june_2025_2.webp": 436,
	"./june_2025_3.webp": 437,
	"./june_2025_4.webp": 438,
	"./june_2025_5.webp": 439,
	"./last.jpg": 440,
	"./left-arrow-with-lines.svg": 1046,
	"./lhs_circle.svg": 223,
	"./liciousImg.svg": 1047,
	"./lithe.jpeg": 199,
	"./logo-green.png": 1048,
	"./logo-green.svg": 1049,
	"./logo-small-green.png": 1050,
	"./logo-small-green.svg": 1051,
	"./logo-white.svg": 1052,
	"./lybra.svg": 193,
	"./ma-1.svg": 441,
	"./ma-2.svg": 442,
	"./ma-3.svg": 443,
	"./ma-4-1.svg": 444,
	"./ma-4.svg": 445,
	"./ma-5.svg": 446,
	"./ma-6.svg": 447,
	"./mar2024-1.jpg": 448,
	"./mar2024-2.jpg": 449,
	"./mar2024-3.jpg": 450,
	"./mar2024-4.jpg": 451,
	"./mar2024-5.jpg": 452,
	"./march2023-1.jpg": 1053,
	"./march2023-2.jpg": 453,
	"./march2023-3.jpg": 454,
	"./march2023-4.jpg": 455,
	"./march2023-5.jpg": 456,
	"./march2025-1.webp": 457,
	"./march2025-2.webp": 458,
	"./march2025-3.webp": 459,
	"./march2025-4.webp": 460,
	"./march2025-5.webp": 461,
	"./march2025-thumbnail.jpeg": 1054,
	"./may2023-1.jpg": 462,
	"./may2023-2.jpg": 463,
	"./may2023-3.jpg": 464,
	"./may2023-4.jpg": 465,
	"./may2023-5.jpg": 466,
	"./may2024-1.jpg": 467,
	"./may2024-2.jpg": 468,
	"./may2024-3.jpg": 469,
	"./may2024-4.jpg": 470,
	"./may2024-5.jpg": 471,
	"./may_2025_1.jpeg": 1055,
	"./may_2025_1.webp": 472,
	"./may_2025_2.webp": 473,
	"./may_2025_3.webp": 474,
	"./may_2025_4.webp": 475,
	"./may_2025_5.webp": 476,
	"./mobile-green-bg.svg": 1056,
	"./moduleCloseButton.svg": 477,
	"./monitor.svg": 1057,
	"./nethronix.svg": 194,
	"./newLogo.png": 1058,
	"./newLogo.svg": 1059,
	"./newLogoold.svg": 1060,
	"./news.jpg": 1061,
	"./news3.jpg": 1062,
	"./news4.jpg": 478,
	"./news5.jpg": 479,
	"./news6.jpg": 480,
	"./news7.jpg": 481,
	"./newsImage.jpg": 1063,
	"./newsletter-2023.png": 482,
	"./nigeria.svg": 1064,
	"./nov2023-1.jpg": 483,
	"./nov2023-2.jpg": 484,
	"./nov2023-3.jpg": 485,
	"./nov2023-4.jpg": 486,
	"./nov2023-5.jpg": 487,
	"./nov2024-1.webp": 488,
	"./nov2024-2.webp": 489,
	"./nov2024-3.jpg": 490,
	"./nov2024-4.webp": 491,
	"./nov2024-5.webp": 492,
	"./oct2023-1.jpeg": 493,
	"./oct2023-2.jpeg": 494,
	"./oct2023-3.jpeg": 495,
	"./oct2023-4.jpeg": 496,
	"./oct2023-5.jpeg": 497,
	"./october2024-1.webp": 498,
	"./october2024-2.webp": 499,
	"./october2024-3.webp": 500,
	"./october2024-4.webp": 501,
	"./october2024-5.webp": 502,
	"./oizom.svg": 221,
	"./pallavi-singh.jpg": 166,
	"./partnership.svg": 218,
	"./pccs.png": 185,
	"./pgso.png": 186,
	"./pharmaCase.jpg": 1065,
	"./platform-image.svg": 1066,
	"./podcast-2.jpg": 1067,
	"./podcast-theme.jpg": 1068,
	"./polycycle.png": 1069,
	"./powerAndRenewables.jpg": 1070,
	"./pricolIcon.png": 1071,
	"./pricolIcon.svg": 1072,
	"./pricolImg.svg": 1073,
	"./profile.jpg": 1074,
	"./raqeeb.png": 187,
	"./raqeeb.svg": 1075,
	"./realtyCase.jpg": 1076,
	"./rhs_circle.svg": 224,
	"./right-arrow-with-lines.svg": 1077,
	"./riskPro.png": 188,
	"./roundImg1.svg": 241,
	"./roundImg2.svg": 242,
	"./rsm.png": 189,
	"./santhosh-jayaram.png": 167,
	"./screenshot-sample.svg": 1078,
	"./scribe.png": 200,
	"./sep2023-1.jpg": 1079,
	"./sep2023-11.jpg": 1080,
	"./september2024-1.jpg": 503,
	"./september2024-2.jpg": 504,
	"./september2024-3.jpg": 505,
	"./september2024-4.jpg": 506,
	"./september2024-5.jpg": 507,
	"./skyMax.jpg": 201,
	"./supplierAssessmentCase.jpg": 1081,
	"./suraksha.png": 190,
	"./suraksha.svg": 1082,
	"./switz_feb_2025.webp": 508,
	"./tanzania.svg": 1083,
	"./td-synnex.svg": 204,
	"./teknoSpec.png": 198,
	"./thailand.jpg": 509,
	"./thinkPlus.png": 191,
	"./thinkplus.svg": 1084,
	"./uae_map.svg": 1085,
	"./uk.jpg": 510,
	"./uk_map.svg": 1086,
	"./unkownUser.svg": 169,
	"./updapt-logo-green.png": 1087,
	"./updapt-logo-white.png": 1088,
	"./usa_map.svg": 1089,
	"./vDimension.jpeg": 203,
	"./view.png": 1090,
	"./view.svg": 1091,
	"./viewww.svg": 1092,
	"./wasteManagementCase.jpg": 1093,
	"./web-green-bg.svg": 1094,
	"./zest.png": 192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;